<template>
  <div class="cont-all">
    <div class="coop-cont">
      <div class="bgImg">
        <div class="img-head">
          <img src="../../../assets/aboutImg/Smile.png" width="94px" height="94px">
        </div>
        <span class="title-head">Q&A</span>
      </div>

      <div class="contact-box">
          <ul>
            <li v-for="item in QAList" :key="item.position"> 
              <div @click="clkxShow(item)">
                <div class="bgblue" >Q{{item.sequence}}</div> 
                <span class="QAtitle">{{item.position}}</span>
                <span>
                  <svg-icon :class="item.isTrue?'up':''"  size="15" name="arrow-down"></svg-icon>
                </span>
              </div>
              <div class="QACent" v-html="item.content" v-show="item.isTrue">
                {{item.content}}
              </div>
            </li>
          </ul>
              <!-- <ul class="joinUs">
                  <li v-for="item in QAList" :key="item.position">
                    <div class="joinUsTitle" @click="clkxShow(item)">
                      <h5 class="l">{{item.position}}</h5>
                      <span class="fa colBlue r font20 marTop20">&#xe620;</span>
                    </div>
                    <div class="joinUsCent" v-show="item.isTrue">
                    </div>                                    
                  </li>
                </ul> -->
        </div>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
  //import topInfo from '../public/topInfo'
  //import footerInfo from '../public/footerInfo'

  export default {
    //components:{topInfo,footerInfo},
    data (){
      return {
        QAList:[
          {
            sequence:1,
            position:'The background of the establishment of Freightshop',
            content:' With the rapid development of information and technology and the changes in foreign trade forms, higher requirements are placed on international logistics. Advantageous price, timeliness of timely feedback, integration of more resources. The working methods of traditional international logistics have gradually no longer adapted to the needs of the new trade.'+
'Freightshop was established in 2014 in response to the situation. Committed to creating the online, intelligent and digitalization of the entire process of international logistics. To help global forwarding companies with development vision to serve their own customers better and faster, improve service quality, and improve service quality.',
            isTrue:true,
          },{
            sequence:2,
             position:'Is Freightshop a freight forwarder or a platform?',
            content:'Freightshop is a freight forwarding company. To be precise, it is a freight forwarding company dedicated to using the Internet platform to help customers.',
            isTrue:false,
          },{
            sequence:3,
             position:'Are the prices on Freightshop competitive?',
            content:'Freightshop is mainly dedicated to the international air transport industry. A total of 46 self-signed cooperative airlines, including EK, EY, TK, CZ, UPS, AM, ET, CK, MU, QR, etc., and integrated the prices of other 235 bookmakers in China (including 21 airports). 68 core cooperation companies.',
            isTrue:false,
          },{
            sequence:4,
             position:' Is there any advantage to cooperating with Freightshop than directly cooperating with other Agents?',
            content:'<p>First of all, in China, many big air freight market makers do not have windows to overseas. They only accept bookings from Chinese freight forwarders. Through more than 6 years of hard work, Freightshop has reached cooperation with more than 150 airlines and 235 air freight first-class bookmakers, of which 68 core bookmakers have reached strategic cooperation. It integrates real-time and online prices in markets such as Europe, North America, South America, Southeast Asia, the Middle East, India and Pakistan, and Africa according to regions.</p>'+
            '<p>Secondly, we firmly believe that service is the first key to gaining customer trust.</p>'+
            '<p>It is embodied in the following aspects:</p>'+
            '<p>1) Guarantee the price is timely and effective: China'+"'s market conditions change every day, and we guarantee that the price will be updated every day to ensure that the price remains unchanged after the customer places an order.</p>"+
            '<p>2) After the customer places an order, from picking up the goods, to warehousing, to confirming the space, then out of the warehouse, customs declaration, take-off, transfer, and finally to the destination, the full name tracking information is actively reported through the mailbox.</p>'+
            '<p>3) The customer service can communicate online in real time, and can communicate online for a certain order and the communication information will always be kept in the order.</p>'+
            '<p>4) Corresponding to the region'+"'s dedicated overseas operators, to ensure timely communication on issues such as booking and placing orders.</p>"+
            '<p>5) Account period guarantee: All WCA agents can cooperate directly to give full account period. At the same time, Beijing, Shanghai, Guangzhou, Shenzhen, and Hong Kong have all joined WCA members.</p>'+
            '<p>6) Own delivery team and customs declaration team to ensure service. Colleagues guarantee the overall level and work efficiency of professional customer service staff.</p>',
            isTrue:false,
          },{
            sequence:5,
             position:' How to register? Are there any billing periods and quotas for WCA members?',
            content:'Enter the upper right corner of the homepage and register via email. WCA member cooperation, Freightshop will directly give USD2W/month with a 30-day billing period.',
            isTrue:false,
          },{
            sequence:6,
             position:'How can I check the air freight price on FREIGHTSHOP?',
            content:'After registering, open your Freightshop system and on the myfreight interface, you can see the daily updated prices from all Chinese airports to these destinations. No need to inquire, and at a glance. Can be arbitrarily inquired according to specific gravity and cargo weight segment.',
            isTrue:false,
          },{
            sequence:7,
             position:'Does the price on Freightshop cover all?',
            content:'The prices of the five major airports in Beijing, Shanghai, Guangzhou, Shenzhen, Hong Kong and other 16 airports in China.',
            isTrue:false,
          },{
            sequence:8,
             position:' Can I place an order directly on Freightshop?',
            content:'Yes, after entering the cargo data, you can place an order directly after selecting the airline company.',
            isTrue:false,
          },{
            sequence:9,
             position:'My company has more than 10 sales staff, do I need to register a Freightshop account for everyone?',
            content:'<p> Not at all. Freightshop has a working group function. You can set different permissions for your peer superiors or subordinates and view the orders of personnel within the corresponding permissions.</p>'+
'<p>There are two main ones, one is USER and the other is admin. Admin can be authorized by several colleagues to see. In addition to seeing his own orders, admin can also see the orders of subordinate USER. USER can only see his own orders.</p>',
            isTrue:false,
          },{
            sequence:10,
             position:'What nodes are included in your tracking information? How to notify me?',
            content:'<p>The tracking information of air cargo includes: Entry warehouse/Booking sucessufl/Out of warehouse/Release customs/Departured/In transit/Arrival airport</p>'+
            '<p>Log in to your Freightshop interface, and you can set the transportation node you care about in the INFO-SETTINGS interface.</p>'+
            '<p>Usually it is an email notification.</p>'+
            '<img src="../../../../static/img/QA/3.png"/>',
            isTrue:false,
          },{
            sequence:11,
             position:'How to pay? Do you have WCA PP?',
            content:'<p>Payment via WCA PP or wire transfer.</p>'+
            '<p>Our WCA PP account is:</p>'+
            '<p>Our USD wire transfer account number is as follows:</p>'+
            '<p>Bank account：（USD）	</p>'+
            '<p>Company name：	Freightshop Technology Co., Ltd</p>'+
            '<p>Account No.：	79160078814800000318</p>'+
            '<p>Bank Name：Shanghai Pudong Development Bank ,Shenzhen branch</p>'+
            '<p>Swift Code：SPDBCNSH030</p>'+
            '<p>Company add.：</p>'+
            '<p>ROOM 2701,FLOOR 27,BLOCK A,WORLD TRADE PLAZA,FUHONG RD,FUTIAN DISTRICT,SHENZHEN</p>'+
            '<p>Bank Add. : </p>'+
            '<p>Shenzhen international chamber of commerce tower Fuhua 3 rd Futian District Shenzhen China.</p>',
            isTrue:false,
          },{
            sequence:12,
             position:'Are relatively large goods only online prices? Is there a channel for individual inquiry?',
            content:'Freightshop has a "SPOT RATE INQUIRY" inquiry channel for goods weighing more than 300KGS, oversize and other special goods. After the inquiry is issued, the system will automatically send it to the airline/Freightshop and the major air freight bookmakers in China who have signed a contract with Freightshop. They will give you the lowest price for the day'+"'s flight according to your cargo type.",
            isTrue:false,
          },{
            sequence:13,
             position:' Can Freightshop pick up goods with batteries?',
            content:'<p>Yes. When checking the price, you can select the airline service that can receive the battery-containing cargo by the type of cargo.</p>'+
            '<img src="../../../../static/img/QA/1.png"/>'+
            '<img src="../../../../static/img/QA/2.png"/>',
            isTrue:false,
          },{
            sequence:14,
             position:'What are the benefits of using Freightshop?',
            content:'<p>a) Check online prices in time, and respond to your customer prices without time difference. There is no need to send an inquiry and wait for the reply of the Chinese forwarder as before.</p>'+
            '<p>b) Reduce communication and improve work efficiency. After cooperating with Freightshop, documents, bills of lading and other information systems will be automatically saved to your account, which is convenient for direct use and does not need to be checked every time, which improves work efficiency.</p>'+
            '<p>c) Tracking information is more transparent and proactive. The entire process of the goods, no need to send emails to urge as before, the Freightshop system will automatically update and push the status of the goods.</p>'+
            '<p>d) Historical orders, I can easily find and view them.</p>'+
            '<p>e) The bill is clear and easy to inquire at any time. No need to look through historical emails to find out.</p>',
            isTrue:false,
          },{
            sequence:15,
             position:' Can the Freigthshop platform check the price between any two cities in China?',
            content:'<p>Yes, through the Freightshop platform, you can easily check the truck transportation cost from any city in China to another city/airport/port for any kilogram segment. And will provide you with different timeliness services and prices for you to choose.</p>'+
            '<p>Freightshop is currently the only website that can check the delivery fees between Chinese cities online in China.</p>',
            isTrue:false,
          }
        ]
      }
      
    },
    created(){   
    },
    methods:{
       //点击标题展开内容
        clkxShow(item){
          item.isTrue=!item.isTrue; 
        },
      
    }
  }
</script>
<style scoped>
  @import "../../../assets/css/about.css";
  .bgImg{
    background: url('../../../../static/img/advantages-bg.png') no-repeat;
    background-position-x: right;
    background-size: 406px 84px;
    
  }
  .img-head{display:inline-block;} 
  .title-head {
    /*display: inline;*/
    width: 75px;
    height: 47px;
    font-size: 40px;
    font-family: 'DINAlternate-Bold, DINAlternate';
    font-weight: bold;
    color: #333333;
    line-height: 47px;
    position: absolute;
    margin: 60px 0 0 0;}
  .img-head img{display: inline-block;margin: 38px 0 0 23px;}
  .bgblue{
    display:inline-block;
    width: 40px;
    height: 24px;
    background: #2E5EB9;
    border-radius: 4px;
    color: #FFFFFF;
    text-align: center;
    line-height: 24px;
  }
  .QACent{
    width: 1080px;
    /* height: 160px; */
    background: #F9F9F9;
    border-radius: 8px;
    margin: 16px 0 25px 50px;
    font-weight: 400;
    color: #555555;
    font-size: 14px;
    padding: 8px;
    font-family: 'PingFangSC-Semibold, PingFang SC';
    line-height: 24px;
  }
  .QAtitle{
    font-size: 16px;
    font-family: 'PingFangSC-Semibold, PingFang SC';
    font-weight: 550;
    color: #333333;
    line-height: 22px;
    margin-left: 10px;
  }
  .contact-box{padding: 0 30px 50px;}
  .contact-box ul li{margin: 20px 0;}
  .up{
    transform: rotate(180deg);
  }

</style>



// WEBPACK FOOTER //
// src/components/reception/otherPage/QA.vue